import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// import fonts
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { StrictMode } from 'react';
import { ThemeProvider } from "../components/providers/ThemeProvider";
import { Backdrop, BrowserRouterProvider, useScrollTransition, useSizeListener, useSizes, useLoadIpinfo } from "common-frontend-components";
import { Switch, Redirect, useLocation, Route } from "react-router-dom";
import { wwwRoutes } from "../variables/wwwRoutes";
import { WwwGalleryPage } from "../views/www/WwwGalleryPage";
import { WwwPostsPage } from "../views/www/WwwPostsPage";
import { useOnAppLoad } from "../hooks/useOnAppLoad";
import { BodyBackgroundContainer } from "../components/backgrounds/BodyBackgroundContainer";
import { TopPage } from "../components/TopPage";
import { WwwAboutPage } from "../views/www/WwwAboutPage";
import { WwwBookPage } from "../views/www/WwwBookPage";
import { WwwGalleryCategoryPage } from "../views/www/WwwGalleryCategoryPage";
import { WwwProductsPage } from "../views/www/WwwProductsPage";
import { WwwHomePage } from "../views/www/WwwHomePage";
import { WwwPrivacyPolicyPage } from "../views/www/WwwPrivacyPolicyPage";
import { WwwTermsAndConditionsPage } from "../views/www/WwwTermsAndConditionsPage";
import { WwwCookiesPolicyPage } from "../views/www/WwwCookiesPolicyPage";
import { WwwContactPage } from "../views/www/WwwContactPage";
import { WwwSearchPage } from "../views/www/WwwSearchPage";
import { WwwProductFullViewPage } from "../views/www/WwwProductFullViewPage";
import { WwwPostFullViewPage } from "../views/www/WwwPostFullViewPage";
const Providers = ({ children }) => {
    return (_jsx(StrictMode, { children: _jsx(ThemeProvider, { children: _jsx(BrowserRouterProvider, { children: children }, void 0) }, void 0) }, void 0));
};
const Hooks = ({ children }) => {
    useSizeListener();
    useScrollTransition();
    useSizes();
    useLoadIpinfo();
    useOnAppLoad();
    return _jsx(_Fragment, { children: children }, void 0);
};
const Routes = () => {
    const { pathname } = useLocation();
    return (_jsxs(Switch, { children: [_jsx(Redirect, { from: "/:url*(/+)", to: pathname.slice(0, -1) }, void 0), _jsx(Route, { path: wwwRoutes.home, exact: true, component: WwwHomePage }, void 0), _jsx(Route, { path: wwwRoutes.posts, exact: true, component: WwwPostsPage }, void 0), _jsx(Route, { path: wwwRoutes.gallery, exact: true, component: WwwGalleryPage }, void 0), _jsx(Route, { path: wwwRoutes.galleryCategory, exact: true, component: WwwGalleryCategoryPage }, void 0), _jsx(Route, { path: wwwRoutes.about, exact: true, component: WwwAboutPage }, void 0), _jsx(Route, { path: wwwRoutes.book, exact: true, component: WwwBookPage }, void 0), _jsx(Route, { path: wwwRoutes.products, exact: true, component: WwwProductsPage }, void 0), _jsx(Route, { path: wwwRoutes.privacy, exact: true, component: WwwPrivacyPolicyPage }, void 0), _jsx(Route, { path: wwwRoutes.terms, exact: true, component: WwwTermsAndConditionsPage }, void 0), _jsx(Route, { path: wwwRoutes.cookies, exact: true, component: WwwCookiesPolicyPage }, void 0), _jsx(Route, { path: wwwRoutes.contact, exact: true, component: WwwContactPage }, void 0), _jsx(Route, { path: wwwRoutes.search, exact: true, component: WwwSearchPage }, void 0), _jsx(Route, { path: wwwRoutes.product, exact: true, component: WwwProductFullViewPage }, void 0), _jsx(Route, { path: wwwRoutes.post, exact: true, component: WwwPostFullViewPage }, void 0), _jsx(Redirect, { from: "*", to: wwwRoutes.home }, void 0)] }, void 0));
};
const Poppers = () => {
    return (_jsx(_Fragment, { children: _jsx(Backdrop, {}, void 0) }, void 0));
};
const App = () => {
    return (_jsxs(BodyBackgroundContainer, { children: [_jsx(TopPage, {}, void 0), _jsx(Routes, {}, void 0), _jsx(Poppers, {}, void 0)] }, void 0));
};
export const UnderConstructionApp = () => {
    return (_jsx(Providers, { children: _jsx(Hooks, { children: _jsx(App, {}, void 0) }, void 0) }, void 0));
};
//# sourceMappingURL=UnderConstructionApp.js.map